import { createTheme } from '@mui/material';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          'backgroundColor': 'darkgreen',
          '&:hover': {
            backgroundColor: '#68b36b',
          },
        },
      },
    },
  },
});

export { theme };
